import ModalTitleButton from "../../SubDashboard/ModalTitleButton/ModalTitleButton";
import DateSelect from "../ScreenListContent/SubScreenList/DateSelect";
import SearchAdminName from "./SubEditContent/SearchAdminName";
import SearchChannelName from "./SubEditContent/SearchChannelName";
import SearchText from "./SubEditContent/SearchText";

function EditContent({ item, closeModal }) {

    console.log(item)

    return (
        <div>
            <div className="fixed top-0 left-0 bg-black opacity-40 w-screen h-screen"></div>
            <div className="fixed top-20 left-1/4 w-3/6 h-4/6 bg-white rounded-lg shadow">
                <ModalTitleButton
                    text="ویرایش"
                    closeModal={closeModal}
                >
                    <div className="m-2 p-8 bg-slate-100 border border-slate-200 rounded-lg mb-10">
                        <SearchChannelName channelName={item.channelName} />
                        <SearchAdminName title=" : نام ادمین" text={item.Admin} />
                        <SearchText title=" : متن" text={item.text} />
                        <div className="flex flex-row-reverse items-center">
                            <p className="w-28 text-right"> : تاریخ</p>
                            <DateSelect date={item.date} />
                        </div>
                    </div>
                </ModalTitleButton>
            </div>
        </div>
    )
}
export default EditContent;